import httpInstance from "../httpInstance";

export const getStatistics = async (jwtToken: string) => {
    let res: any;
    const endpoint = `stats/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        }
    };

    await httpInstance.get(endpoint, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const getAdminStatistics = async (jwtToken: string) => {
    let res: any;
    const endpoint = `adminStats/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        }
    };

    await httpInstance.get(endpoint, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const downloadStatistics = async (jwtToken: string) => {
    let res: any;
    const endpoint = `downloadStats/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`
        },
        responseType: 'blob' as 'json'
    };

    await httpInstance.get(endpoint, config)
        .then((response) => {
            // Crear un enlace temporal y hacer clic en él para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'estadísticas.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            res = response;
        })
        .catch((error) => {
            console.error('Error al descargar estadísticas:', error);
            res = error.response;
        });
    return res;
};